import { Input, InputProps } from '@chakra-ui/react';
import { UseFormReturn, FieldPath } from 'react-hook-form';

type MenuCategoryNameInputProps<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const MenuCategoryNameInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: MenuCategoryNameInputProps<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: 'カテゴリー名は255文字以内にする必要があります。',
      },
    })}
    {...inputProps}
  />
);
